module.exports = __webpack_public_path__ + "assets/3f028d5c51a8fde3e34fc90493045950.svg";